// theme/src/gift-wrap/src/packaging/components/PackagingSteps.jsx
import React from 'react';
import { HeaderView } from '../../components/GiftWrapModal/Header';
import { GiftPresentation } from '../../components/GiftPresentation';
import { useGiftWrapContext } from '../../context/GiftWrapContext';
import { useLocale } from '../../context/LocaleContext';
import { usePackaging } from '../PackagingContext';
import { selectionReducer } from '../selection';
import { getStepCopy } from '../copy';
import { ChooseBoxStep } from './ChooseBoxStep';
import { GiftPresentationStep } from './GiftPresentationStep';
import { PackagingFooter } from './PackagingFooter';
import styles from '../packaging.module.css';
import modalStyles from '../../components/GiftWrapModal/modal.module.css';

/** Steps 1-2 of the packaging journey. Step 3 is the card builder's addPersonalTouch page. */
export function PackagingSteps({ onClose }) {
  const { selection, dispatch, groups, stepState, leaveSteps } = usePackaging();
  const { giftInfo } = useGiftWrapContext();
  const { formatPrice } = useLocale();
  const { step } = selection;
  const copy = getStepCopy({
    step,
    sealEligible: stepState.sealEligible,
    stampPrice: groups.stampBag?.variants?.[0]?.price ?? null,
    formatPrice
  });

  const footer =
    step === 1
      ? {
          primaryLabel: 'CONTINUE',
          primaryDisabled: !stepState.canContinueStep1,
          onPrimary: () => (stepState.hasPresentationStep ? dispatch({ type: 'goToStep', step: 2 }) : leaveSteps(selection))
        }
      : {
          primaryLabel: 'CONTINUE',
          primaryDisabled: !stepState.canContinueStep2,
          onPrimary: () => leaveSteps(selection),
          secondaryLabel: 'NOT THIS TIME',
          onSecondary: () => {
            const next = selectionReducer(selection, { type: 'clearPresentation' });
            dispatch({ type: 'clearPresentation' });
            leaveSteps(next);
          }
        };
  // With one eligible box step 1 was skipped, so there is nothing to go back to.
  const onBack = step === 2 && !stepState.skipBoxStep ? () => dispatch({ type: 'goToStep', step: 1 }) : null;

  return (
    <>
      <div className={step === 1 ? styles.headerWithBadge : undefined}>
        <HeaderView
          titleBar={copy.titleBar}
          heading={copy.heading}
          description={copy.intro}
          onBack={onBack}
          onClose={onClose}
        />
      </div>
      <div className={modalStyles['giftWrap__modal-content']}>{step === 1 ? <ChooseBoxStep /> : <GiftPresentationStep />}</div>
      <PackagingFooter {...footer} />
      {giftInfo && <GiftPresentation />}
    </>
  );
}
